import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  StyledIcon,
  StyledIconDark,
  Styledbox,
  StyledText,
  StyledTextDark
} from './styleApp';

const App = ({
  className,
  title,
  icon,
  dark,
  history,
  goTo,
  onClickBack,
  id
}) => {
  const Icon = dark ? StyledIconDark : StyledIcon;
  const Text = dark ? StyledText : StyledTextDark;
  return (
    <Styledbox
      className={className}
      onClick={() => {
        if (onClickBack) {
          onClickBack();
        }
        history.push(goTo);
      }}
      id={`${id}Interno`}
    >
      <Icon size="xl" svg={icon} className="App-icon" />
      <Text className="App-text">{title}</Text>
    </Styledbox>
  );
};

App.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  dark: PropTypes.bool,
  goTo: PropTypes.string,
  icon: PropTypes.shape({
    viewBox: PropTypes.string,
    url: PropTypes.string
  })
};

export default withRouter(App);
